import React from 'react'
import NavLinks from './NavLinks'
import { MenuOverlay } from './MenuOverlay'
import { FaBarsStaggered } from 'react-icons/fa6'
import { AiOutlineClose } from 'react-icons/ai'
import { Link } from 'react-router-dom'
import logo from '../assets/logo.png'
import { ThemeToggle } from './ui/ThemeToggle'
import './navbar.css'

export const linkItems = [
  { name: 'About', path: '/about' },
  { name: 'Work', path: '/projects' },
  { name: 'Writing', path: '/writing' },
  { name: 'Contact', path: '/contact' },
]

export const NavBar = () => {
  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <nav className=' z-50 fixed top-0 left-0 right-0 bg-cream/80 backdrop-blur-md border-b border-ink/10'>
      <div className=' max-w-7xl mx-auto px-6 md:px-10 h-[68px] flex items-center justify-between'>
        <Link to={'/'} className=' flex items-center gap-3'>
          <img src={logo} alt='Wilson logo' className=' w-9 h-9 rounded-md' />
          <span className=' font-display font-semibold text-lg tracking-tight text-maroon'>Wilson&nbsp;O.</span>
        </Link>

        <div className=' hidden md:flex items-center gap-10'>
          <ul className=' flex items-center gap-8'>
            {linkItems.map((item, i) => (
              <li key={i} className=' nav-items text-xs font-medium uppercase tracking-[0.18em] text-ink/60'>
                <NavLinks href={item.path} name={item.name} />
              </li>
            ))}
          </ul>
          <span className=' flex items-center gap-2 text-xs font-medium uppercase tracking-[0.18em] text-maroon'>
            <span className=' relative flex h-2 w-2'>
              <span className=' animate-ping absolute inline-flex h-full w-full rounded-full bg-mint opacity-75'></span>
              <span className=' relative inline-flex rounded-full h-2 w-2 bg-mint-deep'></span>
            </span>
            Available
          </span>
          <ThemeToggle />
        </div>

        <div className=' flex items-center gap-3 md:hidden'>
          <ThemeToggle />
          <button className=' text-maroon' onClick={() => setIsOpen(v => !v)} aria-label='Toggle menu'>
            {isOpen ? <AiOutlineClose className=' text-2xl' /> : <FaBarsStaggered className=' text-xl' />}
          </button>
        </div>
      </div>
      {isOpen ? <MenuOverlay links={linkItems} close={() => setIsOpen(false)} /> : null}
    </nav>
  )
}
